import {TextField} from "@mui/material";
import {DatePicker, LocalizationProvider} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import locale from "date-fns/locale/hu";
import React from "react";
import {formatHuman} from "../../utils/utils";


const CustomDatePicker = ({errors, setErrors, data, setData, name, validators, ...rest}) => {

    const handleChange = (newValue) => {
        setData({...data, [name]: newValue});
        if (rest?.sideEffect) rest.sideEffect(newValue)
    };

    const handleBlur = (newValue) => {
        for (let validator of validators[name]) {
            const {valid, error} = validator(newValue)
            if (!valid) {
                setErrors({...errors, [name]: error})
                break
            } else setErrors({...errors, [name]: ''})
        }
    };

    return <LocalizationProvider dateAdapter={AdapterDateFns} locale={locale}>
        <DatePicker
            value={data[name]}
            onChange={(event, newValue) => {
                handleBlur(newValue || event)
                handleChange(newValue || event)
            }}
            onBlur={handleBlur}
            inputFormat="yyyy-MM-dd"
            mask="____-__-__"
            {...rest}
            InputAdornmentProps={{ position: 'start' }}
            renderInput={params => <TextField {...params} error={Boolean(errors[name])} helperText={errors[name] && errors[name]} name={name} />}
        />
    </LocalizationProvider>
}

export default CustomDatePicker
